<div fxLayout="row" fxLayoutAlign="end center" class="h-100-p">
    <p class="copyright mr-16">Copyright {{ copyrightYear }}</p>
    <img *ngIf="appInfo.pdfExport.logo1" [src]="appInfo.pdfExport.logo1" class="mr-16" />
</div>
